import React, { useState } from "react";
import { Box, IconButton, Popover, Popper, Typography, makeStyles } from "@material-ui/core";
import { InfoOutlined, ChevronRight } from "@material-ui/icons";
import { observer } from "mobx-react";
import { ChatBotStore } from "../../stores/chatBotStore";

const useStyles = makeStyles((theme) => ({
  popOverMenu: {
    "& .MuiPopover-paper": {
      borderRadius: 16,
    }
  },
  menu: {
    padding: 8,
    borderRadius: 16,
    minWidth: 220,
    border: "1px solid #c7d2fe",
  },
  item: {
    display: "flex",
    justifyContent: "space-between",
    padding: "10px 12px",
    borderRadius: 20,
    cursor: "pointer",
    "&:hover": {
      background: "#eef2ff",
    },
  },
  activeItem: {
    background: "#d1e7ea",
  },
  submenu: {
    padding: 12,
    borderRadius: 16,
    minWidth: 260,
    background: "#f8f9fb",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #c7d2fe",
  },
  submenuItem: {
    padding: "10px 12px",
    borderRadius: 20,
    cursor: "pointer",
    "&:hover": {
      background: "#c7e3e7",
    },
  },
  button: {
    backgroundColor: '#A4E0E9',
    color: theme.palette.common.black,
    borderRadius: 20,
    padding: 6,
    "&:hover": {
      backgroundColor: "#6FBCC6",
    },
  },
}));

interface InformationButtonMenuProps {
  store: ChatBotStore;
}

export const InformationButtonMenu = observer(({ store }: InformationButtonMenuProps) => {
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [submenuAnchor, setSubmenuAnchor] = useState<HTMLElement | null>(null);
  const [active, setActive] = useState<string | null>(null);

  const open = Boolean(anchorEl);
  const submenuOpen = Boolean(submenuAnchor) && Boolean(anchorEl);

  const handleOptionClick = async (selectedOption: string) => {
    await store.sendMessage(selectedOption);
    handleClose();
  }
  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuAnchor(null);
    setActive(null);
  }

  return (
    <Box>
      <IconButton className={classes.button} size="small" onClick={(e) => setAnchorEl(e.currentTarget)}>
        <InfoOutlined fontSize="medium" />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        className={classes.popOverMenu}
        onClose={() => {
          handleClose();
        }}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box className={classes.menu}>
          {Object.keys(store.informationOptions || {}).map((key) => (
            <Box
              key={key}
              className={`${classes.item} ${active === key ? classes.activeItem : ""
                }`}
              onMouseEnter={(e) => {
                setActive(key);
                setSubmenuAnchor(e.currentTarget);
              }}
            >
              <Typography>{key}</Typography>
              <ChevronRight />
            </Box>
          ))}
        </Box>
      </Popover>

      <Popper
        open={submenuOpen}
        anchorEl={submenuAnchor}
        placement="right-end"
        style={{ zIndex: 2000 }}
        modifiers={{
          flip: {
            enabled: false,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: "viewport",
            padding: 8,
          },
        }}
      >
        <Box className={classes.submenu}>
          {active && store.informationOptions && store.informationOptions[active] &&
            store.informationOptions[active].map((item) => (
              <Box
                key={item}
                className={classes.submenuItem}
                onClick={() => handleOptionClick(item)}>
                <Typography>{item}</Typography>
              </Box>
            ))}
        </Box>
      </Popper>
    </Box>
  );
});